import { qrcode } from "./dependencies";
import { qrConfig } from "./config/contact";
import { accessibility, messages } from "./config/ui";
import { palette } from "./theme";
import { requireElement } from "./dom";
import { profile } from "./config/profile";

export const qr = qrcode(qrConfig.version, qrConfig.errorCorrection);

qr.addData(qrConfig.content, qrConfig.encoding);
qr.make();
export const size = qr.getModuleCount();
export const stage = requireElement("#stage");
// Keep the QR available if WebGL cannot start.
export const fallback = document.createElement("canvas");
fallback.width = fallback.height =
	(size + qrConfig.quietZoneModules * 2) * qrConfig.fallbackModulePixels;
fallback.className = "qr-fallback";
fallback.classList.add("ui-surface");
fallback.setAttribute("aria-label", accessibility.qr);
const fallbackContext = fallback.getContext("2d");
if (!fallbackContext) throw new Error(messages.noCanvas);
fallbackContext.fillStyle = palette["qr-paper"];
fallbackContext.fillRect(0, 0, fallback.width, fallback.height);
fallbackContext.fillStyle = palette.ink;
for (let y = 0; y < size; y++)
	for (let x = 0; x < size; x++) {
		if (qr.isDark(y, x))
			fallbackContext.fillRect(
				(x + qrConfig.quietZoneModules) * qrConfig.fallbackModulePixels,
				(y + qrConfig.quietZoneModules) * qrConfig.fallbackModulePixels,
				qrConfig.fallbackModulePixels,
				qrConfig.fallbackModulePixels,
			);
	}
stage.appendChild(fallback);

const copyButton = requireElement("#copy-email");
const copyToast = requireElement("#copy-toast");
let toastTimer: ReturnType<typeof setTimeout> | undefined;
copyButton.addEventListener("click", async () => {
	let copied = false;
	try {
		await navigator.clipboard.writeText(profile.email);
		copied = true;
	} catch {
		// Support local files and browsers without Clipboard API access.
		const field = document.createElement("textarea");
		field.value = profile.email;
		field.readOnly = true;
		field.style.position = "fixed";
		field.style.opacity = "0";
		document.body.appendChild(field);
		try {
			field.select();
			copied = document.execCommand("copy");
		} catch {
			copied = false;
		} finally {
			field.remove();
			copyButton.focus({ preventScroll: true });
		}
	}
	clearTimeout(toastTimer);
	copyToast.textContent = copied
		? messages.emailCopied
		: messages.emailCopyFailed;
	toastTimer = setTimeout(() => {
		copyToast.textContent = "";
	}, 2500);
});
